import React from "react";
import Card from '@mui/material/Card';

export default function DHCard({text}) {
    return <Card variant="outlined" style={{margin:10}}>{text}</Card>
}